<template>
    <div class="container admin-table-page">
        <!-- Fila del título y flecha hacia atrás -->
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100">
                <div class="d-flex align-items-center">
                    <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                        <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" class="back-icon" />
                    </b-button>
                    <h2 class="param-title">{{ labels.title }}</h2>
                </div>
            </div>
        </div>
        
        <!-- Fila de filtros debajo del título -->
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100">
                <!-- Contenedor de filtros a la izquierda -->
                <div class="filters-container d-flex align-items-center">
                    <b-form-select
                        id="report-select"
                        v-model="fechaSaldos"
                        class="filter-select"
                        :disabled="isLoading"
                    >
                        <b-form-select-option value="">
                            {{ labels.selectReport }}
                        </b-form-select-option>
                        <option 
                            v-for="item in lstFechaSaldos" 
                            :key="item?.id" 
                            :value="item?.vigencia"
                        > 
                            {{ item?.vigencia }} 
                        </option>
                    </b-form-select>                  
                    <b-button
                        class="consult-btn ml-2"
                        @click="consultSaldosPorContrato()"
                        :disabled="!fechaSaldos || isLoading"
                    >
                        <font-awesome-icon :icon="['fas', 'search']" class="mr-1" />
                        {{ labels.consultar }}
                    </b-button>
                </div>
                
                <!-- Información del contrato en una sola fila (se muestra a la derecha cuando hay detalle) -->
                <div v-if="mostrarDetalleContrato && contratoSeleccionado" class="detail-contrato ml-auto">
                    <span class="info-item">
                        <span class="info-label">{{ labels.contrato }}:</span>
                        <span class="info-value">{{ contratoSeleccionado }}</span>
                    </span>
                    <span class="info-divider">|</span>
                    <span class="info-item">
                        <span class="info-label">{{ labels.tipoContrato }}:</span>
                        <span class="info-value">{{ tipoContrato(contratoSeleccionado) || 'N/A' }}</span>
                    </span>
                    <span class="info-divider">|</span>
                    <span class="info-item">
                        <span class="info-label">{{ labels.fechaInicial }}:</span>
                        <span class="info-value">{{ fechaIni(contratoSeleccionado) || 'N/A' }}</span>
                    </span>
                    <span class="info-divider">|</span>
                    <span class="info-item">
                        <span class="info-label">{{ labels.fechaFinal }}:</span>
                        <span class="info-value">{{ fechaFin(contratoSeleccionado) || 'N/A' }}</span>
                    </span>
                </div>
            </div>
        </div>
        
        <!-- Tabla -->
        <div class="admin-table-block mt-4">
            <div v-if="!isLoading">
                <CorporateDataTable
                    :key="tableKey"
                    :items="lstSaldos"
                    :fields="allFields"
                    :labels="tableLabels"
                    :default-per-page="10"
                    :page-options="[10, 20, 50, 100, 500]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="showSearchTable"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="tableFilterDefs"
                    :toolbar-disabled="!showToolbarExtras"
                    :enable-row-click="enableRowClick"
                    @row-clicked="handleRowClick"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right">
                            <b-button
                                size="sm"
                                class="table-toolbar-excel-btn"
                                @click="genExcelSaldContabPorCont()"
                                :disabled="!showToolbarExtras || lstSaldos.length === 0"
                            >
                                <font-awesome-icon :icon="['fas', 'file-excel']" class="mr-1" />
                            </b-button>
                        </div>
                    </template>
                    <template #cell(identificacion)="data">
                        <div class="text-left">{{ proveedor(data.item?.identificacion) }}</div> 
                    </template>
                </CorporateDataTable>
            </div>

            <!-- Spinner de carga -->
            <div v-if="isLoading" class="text-center py-5">
                <b-spinner></b-spinner>
                <p class="mt-2">{{ labels.loading }}</p>
            </div>
        </div>
    </div>
</template>
<script>
import Contrato from '../../services/Contrato.js';
import ContratoSaldos from '../../services/ContratoSaldos'; 
import Tercero from '../../services/Tercero'; 
import Authentication from "../../services/Authentication" 
import CorporateDataTable from '../utils/CorporateDataTable.vue';
import * as XLSX from "exceljs";
import TipoContrato from '../../services/TipoContrato.js';

export default {
    name : 'ConsultaSaldosContables',
    components : {CorporateDataTable},
    data : () => ({
        nameCompania : '',
        showPorContrato : false,
        showPorCuenta : false,
        fechaSaldos : '',
        lstFechaSaldos : [],
        lstSaldContab : [],
        lstSaldos : [],
        lstSaldPorCuenta : [],
        listTercero : [],
        listContratos : [],
        listTipoContrato : [],
        isLoading: false,
        showToolbarExtras: false,
        filtroContrato: '',
        showModal : false,
        contrato : '',
        vigencia : '',
        numCuenta : null,
        showModContXCue : false,
        listCuentPorContr : [],
        listContrPorCuent : [],
        btnGenExcel : false,
        loading: false,
        // Nuevas propiedades para el detalle de contrato
        contratoSeleccionado: null,
        vigenciaSeleccionada: null,
        mostrarDetalleContrato: false,
        tableKey: 0,
        // Propiedades para la información del contrato
        infoContrato: {
            fechaInicial: null,
            fechaFinal: null,
            tipoContrato: '',
            proveedor: '',
            identificacion: ''
        }
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Consulta saldos',
                    subTitle : 'Consulta por contrato',
                    subTitleCuenta : 'Consulta por cuenta',
                    fechaSaldos : 'Fecha saldos:',
                    fecha : 'Fecha causación',
                    consultar : 'Consultar',
                    noRow : 'No hay registros',
                    consPorContrato : 'Consulta por contrato',
                    consPorCuenta : 'Consulta por cuenta',
                    selectReport: 'Seleccione Fecha',
                    loading: 'Cargando...',
                    seleccion : 'Seleccione...',
                    contrato: 'Contrato',
                    tipoAct: 'Tipo activo',
                    proveedor: 'Proveedor',
                    filterContrato: 'Filtrar contrato...',
                    filterTipoAct: 'Filtrar tipo activo...',
                    filterProveedor: 'Filtrar proveedor...',
                    filterCentrCost: 'Filtrar centro costo...',
                    noData: 'No hay datos disponibles',
                    noMatches: 'No se encontraron resultados',
                    searchPlaceholder: 'Buscar en la tabla...',
                    rowsPerPage: 'Filas por página:',
                    noSort: 'Sin orden',
                    sortAsc: 'A-Z / Menor a mayor',
                    sortDesc: 'Z-A / Mayor a menor',
                    columns: 'Columnas',
                    showAllColumns: 'Mostrar todas',
                    filters: 'Filtros',
                    clearFilters: 'Limpiar filtros',
                    volver: 'Volver',
                    detalleContrato: 'Detalle del contrato',
                    vigenciaLabel: 'Vigencia',
                    saldo: 'Saldo',
                    cuenta: 'Cuenta',
                    nombre: 'Nombre',
                    centroCosto: 'Centro Costo',
                    volverTodos: 'Volver a todos los contratos',
                    filterCuenta: 'Filtrar cuenta...',
                    filterNombre: 'Filtrar nombre...',
                    filterSaldo: 'Filtrar saldo...',
                    generarExcel: 'Generar Excel',
                    fechaInicial: 'Fecha inicial',
                    fechaFinal: 'Fecha final',
                    tipoContrato: 'Tipo contrato',
                    proveedorLabel: 'Proveedor',
                    informacionContrato: 'Información del contrato'
                }
            }else{
                return {
                    title : 'Check balances',
                    subTitle : 'Contract consultation',
                    subTitleCuenta : 'Inquiry by account',
                    fechaSaldos : 'Balance date:',
                    fecha : 'Balance date',
                    consultar : 'Consult',
                    noRow : 'There are no records',
                    consPorContrato : 'Contract consultation',
                    consPorCuenta : 'Inquiry by account',
                    selectReport: 'Select Date',
                    loading: 'Loading...',
                    seleccion : 'Select...',
                    contrato: 'Contract',
                    tipoAct: 'Active type',
                    proveedor: 'Provider',
                    filterContrato: 'Filter contract...',
                    filterTipoAct: 'Filter asset type...',
                    filterProveedor: 'Filter provider...',
                    filterCentrCost: 'Filter cost center...',
                    noData: 'No data available',
                    noMatches: 'No results found',
                    searchPlaceholder: 'Search in table...',
                    rowsPerPage: 'Rows per page:',
                    noSort: 'No sorting',
                    sortAsc: 'A-Z / Low to high',
                    sortDesc: 'Z-A / High to low',
                    columns: 'Columns',
                    showAllColumns: 'Show all',
                    filters: 'Filters',
                    clearFilters: 'Clear filters',
                    volver: 'Back',
                    detalleContrato: 'Contract details',
                    vigenciaLabel: 'Validity',
                    saldo: 'Balance',
                    cuenta: 'Account',
                    nombre: 'Name',
                    centroCosto: 'Cost Center',
                    volverTodos: 'Back to all contracts',
                    filterCuenta: 'Filter account...',
                    filterNombre: 'Filter name...',
                    filterSaldo: 'Filter balance...',
                    generarExcel: 'Generate Excel',
                    fechaInicial: 'Start date',
                    fechaFinal: 'End date',
                    tipoContrato: 'Contract type',
                    proveedorLabel: 'Provider',
                    informacionContrato: 'Contract information'
                }
            }
        },
        allFields() {
            // Si estamos viendo detalle de contrato y hay datos
            if (this.mostrarDetalleContrato && this.lstSaldos.length > 0) {
                // Verificar si los datos tienen las propiedades de saldos
                const primerItem = this.lstSaldos[0];
                const tieneSaldos = primerItem && (
                    primerItem.cuenta || 
                    primerItem.nombre || 
                    primerItem.saldo !== undefined
                );
                
                if (tieneSaldos) {
                    return [
                        { 
                            key: 'cuenta', 
                            label: this.labels.cuenta, 
                            sortable: true, 
                            thClass: 'text-center', 
                            tdClass: 'text-center align-middle',
                            thStyle: { whiteSpace: 'nowrap', minWidth: '120px' }
                        },
                        { 
                            key: 'nombre', 
                            label: this.labels.nombre, 
                            sortable: true, 
                            thClass: 'text-left', 
                            tdClass: 'text-start align-middle',
                            thStyle: { whiteSpace: 'nowrap', minWidth: '200px' }
                        },
                        { 
                            key: 'identificacion', 
                            label: this.labels.proveedor, 
                            sortable: true, 
                            thClass: 'text-center', 
                            tdClass: 'text-start align-middle',
                            thStyle: { whiteSpace: 'nowrap', minWidth: '150px' }
                        },
                        { 
                            key: 'tipo_activo', 
                            label: this.labels.tipoAct, 
                            sortable: true, 
                            thClass: 'text-left', 
                            tdClass: 'text-start align-middle',
                            thStyle: { whiteSpace: 'nowrap', minWidth: '120px' }
                        },
                        { 
                            key: 'centro_costo', 
                            label: this.labels.centroCosto, 
                            sortable: true, 
                            thClass: 'text-center', 
                            tdClass: 'text-center align-middle',
                            thStyle: { whiteSpace: 'nowrap', minWidth: '120px' }
                        },
                        { 
                            key: 'saldo', 
                            label: this.labels.saldo, 
                            sortable: true, 
                            thClass: 'text-right', 
                            tdClass: 'text-end align-middle',
                            thStyle: { whiteSpace: 'nowrap', minWidth: '120px' },
                            formatter: (value) => {
                                return value !== undefined ? this.formatCurrency(value) : '';
                            }
                        },
                    ];
                }
            }
            
            // Vista normal de contratos (vista general)
            return [
                { 
                    key: 'nro_contrato', 
                    label: this.labels.contrato, 
                    sortable: true, 
                    thClass: 'text-center', 
                    tdClass: 'text-center align-middle', 
                    thStyle: { whiteSpace: 'nowrap', minWidth: '100px' } 
                },
                { 
                    key: 'tipo_activo', 
                    label: this.labels.tipoAct, 
                    sortable: true, 
                    thClass: 'text-left', 
                    tdClass: 'text-start align-middle', 
                    thStyle: { whiteSpace: 'nowrap', minWidth: '120px' } 
                },
                { 
                    key: 'identificacion', 
                    label: this.labels.proveedor, 
                    sortable: true, 
                    thClass: 'text-center', 
                    tdClass: 'text-start align-middle', 
                    thStyle: { whiteSpace: 'nowrap', minWidth: '400px' }
                },
            ];
        },        
        tableFilterDefs() {
            // Si estamos en detalle, filtros diferentes
            if (this.mostrarDetalleContrato) {
                return [
                    { key: 'cuenta', type: 'text', placeholder: this.labels.filterCuenta },
                    { key: 'nombre', type: 'text', placeholder: this.labels.filterNombre },
                    { key: 'identificacion', type: 'text', placeholder: this.labels.filterProveedor },
                    { key: 'tipo_activo', type: 'text', placeholder: this.labels.filterTipoAct },
                    { key: 'centro_costo', type: 'text', placeholder: this.labels.filterCentrCost },
                    { key: 'saldo', type: 'text', placeholder: this.labels.filterSaldo },
                ];
            }
            
            return [
                { key: 'nro_contrato', type: 'text', placeholder: this.labels.filterContrato },
                { key: 'tipo_activo', type: 'text', placeholder: this.labels.filterTipoAct },
                { key: 'identificacion', type: 'text', placeholder: this.labels.filterProveedor },
            ];
        },        
        tableLabels() {
            return {
                noRow: this.labels.noData,
                noMatches: this.labels.noMatches,
                searchPlaceholder: this.labels.searchPlaceholder,
                rowsPerPage: this.labels.rowsPerPage,
                noSort: this.labels.noSort,
                sortAsc: this.labels.sortAsc,
                sortDesc: this.labels.sortDesc,
                columns: this.labels.columns,
                showAllColumns: this.labels.showAllColumns,
                filters: this.labels.filters,
                clearFilters: this.labels.clearFilters
            };
        },
        showSearchTable() {
            return true;
        },
        // Propiedad para controlar si la tabla debe tener evento de click
        enableRowClick() {
            // Solo habilitar click en la vista general
            return !this.mostrarDetalleContrato;
        },
        // Propiedad para controlar el título del Excel
        excelFileName() {
            if (this.mostrarDetalleContrato && this.contratoSeleccionado) {
                return `Saldos_Contrato_${this.contratoSeleccionado}_${this.fechaSaldos}`;
            }
            return `Saldos_por_Contrato_${this.fechaSaldos}`;
        },
        // Propiedad para verificar si hay información del contrato
        hasInfoContrato() {
            return this.mostrarDetalleContrato && 
                   this.contratoSeleccionado && 
                   (this.infoContrato.fechaInicial || 
                    this.infoContrato.fechaFinal || 
                    this.infoContrato.tipoContrato ||
                    this.infoContrato.proveedor);
        }
    },
    methods : {
        goBack() {
            // Si estamos en vista de detalle, volver a la vista general
            if (this.mostrarDetalleContrato) {
                this.volverVistaGeneral();
                return;
            }
            
            // Si no estamos en detalle, ir a la página anterior
            this.$router.back();
        },
        
        async consultSaldosPorContrato(){
            if (!this.fechaSaldos) {
                this.$toast.error(this.$store.state._language === 'es-ES'
                    ? 'Diligenciar la fecha.'
                    : 'Please select a date.');
                return;
            }

            // Resetear modo detalle
            this.mostrarDetalleContrato = false;
            this.contratoSeleccionado = null;
            this.vigenciaSeleccionada = null;
            this.limpiarInfoContrato();
            this.tableKey += 1;

            this.isLoading = true;

            try {
                const res = await ContratoSaldos.getContratoSaldosByVig(this.fechaSaldos);
                this.lstSaldos = res.data.listaSaldos || [];
                this.showToolbarExtras = this.lstSaldos.length > 0;
                this.showPorContrato = true;
                this.showPorCuenta = false;

                if (!this.lstSaldos.length) {
                    this.$toast.warning(this.$store.state._language === 'es-ES'
                        ? 'No hay datos para la fecha seleccionada.'
                        : 'No data available for the selected date.'
                    );
                }

            } catch (error) {
                console.error('Error en consulReportPorContrato:', error);
                const message = error.response?.data?.message || 
                    (this.$store.state._language === 'es-ES'
                        ? 'Error al consultar los datos.'
                        : 'Error fetching data.'
                    );
                this.$toast.error(message);
                this.lstSaldos = [];
                this.showToolbarExtras = false;

            } finally {
                this.isLoading = false;
            }
        },
        
        consultSaldosPorCuenta(){
            if(this.fechaSaldos != ''){ 
                this.loading = true;
                this.mostrarDetalleContrato = false;
                this.limpiarInfoContrato();
                
                ContratoSaldos.getCuentasSaldosByVig(this.fechaSaldos) 
                .then((result) => { 
                    this.lstSaldPorCuenta = result.data.listaSaldosPorCuenta;
                    this.btnGenExcel = true;
                    this.showPorCuenta = true;
                    this.showPorContrato = false;
                }).catch((err) => { 
                    console.log(err);
                    this.$toast.error('Error al consultar saldos por cuenta.');
                })
                .finally(() => { 
                    this.loading = false;
                });
            }else{
                this.$toast.error('Diligenciar la fecha.');
            }
        },
        
        proveedor(identify){
            if (identify == null || identify == undefined) {
                return identify;
            }
            let nameTercero = this.listTercero.find((tercer) => tercer.identificacion === identify);
            
            if (nameTercero == undefined) {
                return "Sin Nombre " + identify;
            }
            return nameTercero?.nombre;
        },
        
        // Método para obtener información detallada del contrato
        /*async obtenerInfoContrato(contrato) {
            try {
                // Aquí debes implementar la llamada a tu API para obtener la información del contrato
                // Este es un ejemplo, ajusta según tu servicio
                const response = await ContratoSaldos.getInfoContrato(contrato);
                if (response && response.data) {
                    this.infoContrato = {
                        fechaInicial: response.data.fechaInicial || null,
                        fechaFinal: response.data.fechaFinal || null,
                        tipoContrato: response.data.tipoContrato || '',
                        proveedor: response.data.proveedor || '',
                        identificacion: response.data.identificacion || ''
                    };
                }
            } catch (error) {
                console.error('Error obteniendo información del contrato:', error);
            }
        },*/
        
        limpiarInfoContrato() {
            this.infoContrato = {
                fechaInicial: null,
                fechaFinal: null,
                tipoContrato: '',
                proveedor: '',
                identificacion: ''
            };
        },
        
        consSaldPorContrCuenta(contrato, vigencia) {
            // Validar que tenga datos
            if (!contrato || !vigencia) {
                this.$toast.warning(
                    this.$store.state._language === 'es-ES'
                        ? 'Datos de contrato incompletos.'
                        : 'Incomplete contract data.'
                );
                return;
            }

            // Mostrar loading
            this.isLoading = true;
            
            // Guardar referencia del contrato seleccionado
            this.contratoSeleccionado = contrato;
            this.vigenciaSeleccionada = vigencia;
            this.mostrarDetalleContrato = true;
            this.tableKey += 1; // Forzar re-render
            
            // Limpiar datos anteriores para mostrar loading
            this.lstSaldos = [];
            this.showToolbarExtras = false;
            
            // Obtener información del contrato
            // this.obtenerInfoContrato(contrato);
            
            ContratoSaldos.getContratoSaldosByContrAndVigen(contrato, vigencia)
                .then((result) => {
                    // Verificar que la respuesta sea válida
                    const data = result?.data?.listaSaldosxContyVig || [];
                    
                    // Actualizar la tabla con los nuevos datos
                    this.lstSaldos = data;
                    this.showToolbarExtras = data.length > 0;
                    
                    // Mostrar mensaje de éxito o advertencia
                    if (!data.length) {
                        this.$toast.warning(
                            this.$store.state._language === 'es-ES'
                                ? `No hay saldos para el contrato ${contrato}.`
                                : `No balances for contract ${contrato}.`
                        );
                    } else {
                        this.$toast.success(
                            this.$store.state._language === 'es-ES'
                                ? `Se encontraron ${data.length} saldos para el contrato ${contrato}.`
                                : `Found ${data.length} balances for contract ${contrato}.`
                        );
                    }
                })
                .catch((err) => {
                    console.error('Error en consSaldPorContrCuenta:', err);
                    
                    const message = err.response?.data?.message || 
                        (this.$store.state._language === 'es-ES'
                            ? 'Error al consultar los saldos del contrato.'
                            : 'Error fetching contract balances.'
                        );
                    
                    this.$toast.error(message);
                    this.lstSaldos = [];
                    this.showToolbarExtras = false;
                    this.mostrarDetalleContrato = false;
                    this.limpiarInfoContrato();
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        
        volverVistaGeneral() {
            this.mostrarDetalleContrato = false;
            this.contratoSeleccionado = null;
            this.vigenciaSeleccionada = null;
            this.limpiarInfoContrato();
            this.tableKey += 1; // Forzar re-render
            
            // Recargar la vista general si hay fecha seleccionada
            if (this.fechaSaldos) {
                this.consultSaldosPorContrato();
            } else {
                this.lstSaldos = [];
                this.showToolbarExtras = false;
                this.$toast.info(
                    this.$store.state._language === 'es-ES'
                        ? 'Seleccione una fecha para consultar.'
                        : 'Select a date to query.'
                );
            }
        },
        
        handleRowClick(item) {
            // Si estamos en vista de detalle, NO hacer nada (deshabilitado)
            if (this.mostrarDetalleContrato) {
                return;
            }
            
            // Si estamos en vista general, consultar detalle del contrato
            if (item.nro_contrato && item.vigencia) {
                this.consSaldPorContrCuenta(item.nro_contrato, item.vigencia);
            } else if (item.nro_contrato) {
                // Si no tiene vigencia, usar la fecha seleccionada
                this.consSaldPorContrCuenta(item.nro_contrato, this.fechaSaldos);
            }
        },
        
        consSaldCuenta(cuenta) {
            if (!cuenta) {
                this.$toast.warning('Cuenta no válida.');
                return;
            }
            
            this.isLoading = true;
            
            ContratoSaldos.getContratosSaldosByVigCuent(this.fechaSaldos, cuenta) 
                .then((result) => { 
                    this.listContrPorCuent = result.data.listaSaldDeContPorCuenta || [];
                    this.numCuenta = cuenta;
                    this.showModContXCue = true;
                    
                    if (!this.listContrPorCuent.length) {
                        this.$toast.warning(
                            this.$store.state._language === 'es-ES'
                                ? `No hay contratos para la cuenta ${cuenta}.`
                                : `No contracts for account ${cuenta}.`
                        );
                    }
                })
                .catch((err) => { 
                    console.error('Error en consSaldCuenta:', err);
                    this.$toast.error('Error al consultar contratos por cuenta.');
                    this.listContrPorCuent = [];
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        
        closeModal(val){
            this.showModal = val;
            this.showModContXCue = val;
        },
        
        async consSaldContByVig(){
            try {
                const res = await ContratoSaldos.consulSaldContByVigencia(this.fechaSaldos);
                this.lstSaldContab = res.data.listSaldContab || [];
            } catch (error) {
                console.error('Error en consSaldContByVig:', error);
                this.$toast.error('Error al consultar saldos contables.');
                this.lstSaldContab = [];
            }
        },
        
        formatCurrency(value) {
            if (value === undefined || value === null) return '';
            const num = parseFloat(value);
            if (isNaN(num)) return value;
            
            return new Intl.NumberFormat(this.$store.state._language === 'es-ES' ? 'es-CO' : 'en-US', {
                style: 'currency',
                currency: 'COP',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(num);
        },
        
        async genExcelSaldContabPorCont() {
            try {
                this.isLoading = true;
                
                // Si estamos en modo detalle, usar los datos de la tabla actual
                let datosExcel = [];
                let tituloExcel = '';
                
                if (this.mostrarDetalleContrato && this.contratoSeleccionado) {
                    // Usar los datos del detalle del contrato
                    datosExcel = this.lstSaldos;
                    tituloExcel = `Saldos del Contrato ${this.contratoSeleccionado} - ${this.fechaSaldos}`;
                } else {
                    // Si no estamos en detalle, consultar todos los datos
                    await this.consSaldContByVig();
                    datosExcel = this.lstSaldContab;
                    tituloExcel = `Saldos por Contrato - ${this.fechaSaldos}`;
                }
                
                if (!datosExcel || datosExcel.length === 0) {
                    this.$toast.warning(
                        this.$store.state._language === 'es-ES'
                            ? 'No hay datos para generar el Excel.'
                            : 'No data to generate Excel.'
                    );
                    return;
                }
                
                const {Workbook} = XLSX;
                const workbook = new Workbook();
                const worksheet = workbook.addWorksheet(tituloExcel);

                if (this.mostrarDetalleContrato && this.contratoSeleccionado) {

                    const titulo = ["Saldos por contrato"]
                    worksheet.addRow(titulo) 
                    worksheet.mergeCells('A1:E1') 
                    worksheet.getCell('A1').font = { name: 'Arial', size: 12, bold: true } 
                    worksheet.getCell('A1').alignment = { horizontal: 'center' } 

                    // =======================
                    // FILA 2 - INFO GENERAL (richText)
                    // =======================
                    worksheet.addRow(['']); 
                    worksheet.mergeCells('A2:E2'); 

                    const cell2 = worksheet.getCell('A2'); 

                    cell2.value = { 
                        richText: [
                            { text: 'Contrato: ', font: { bold: true } },
                            { text: `${this.contratoSeleccionado} | ` }, 

                            { text: 'Tipo contrato: ', font: { bold: true } },
                            { text: `${this.tipoContrato(this.contratoSeleccionado)} | ` },

                            { text: 'Proveedor: ', font: { bold: true } },
                            { text: `${this.proveedorName(this.contratoSeleccionado)} | ` },

                            { text: 'Compañía: ', font: { bold: true } },
                            { text: `${this.nameCompania}` }, 
                        ]
                    };

                    cell2.font = { name: 'Arial', size: 12 }; 
                    cell2.alignment = { horizontal: 'center', vertical: 'middle' }; 

                    // =======================
                    // FILA 3 - MÁS INFO (richText)
                    // =======================
                    worksheet.addRow(['']); 
                    worksheet.mergeCells('A3:E3'); 

                    const cell3 = worksheet.getCell('A3'); 

                    cell3.value = { 
                        richText: [

                            { text: 'Fecha inicial: ', font: { bold: true } },
                            { text: `${this.fechaIni(this.contratoSeleccionado)} | ` }, 

                            { text: 'Fecha final: ', font: { bold: true } },
                            { text: `${this.fechaFin(this.contratoSeleccionado)} | ` },

                            { text: 'Generado por: ', font: { bold: true } },
                            { text: `${this.$store.state.userName} | ` }, 

                            { text: 'Fecha generación: ', font: { bold: true } },
                            { text: `${this.fechaActual()}` }, 
                        ]
                    };

                    cell3.font = { name: 'Arial', size: 12 }; 
                    cell3.alignment = { horizontal: 'center', vertical: 'middle' }; 

                    worksheet.addRow(['']); 
                    worksheet.mergeCells('A4:E4')

                }else{
                    // Título principal
                    worksheet.addRow([tituloExcel]);
                    worksheet.mergeCells('A1:G1');
                    worksheet.getCell('A1').font = { name: 'Arial', bold: true, size: 11 };
                    worksheet.getCell('A1').alignment = { horizontal: 'center' };
                    
                    // Fila de información
                    worksheet.addRow(['']);
                    worksheet.mergeCells('A2:G2');
                    const cell2 = worksheet.getCell('A2');
                    cell2.value = {
                        richText: [
                            { text: 'Generado por: ', font: { bold: true } },
                            { text: `${this.$store.state.userName} | ` },
                            { text: 'Fecha generación: ', font: { bold: true } },
                            { text: `${this.fechaActual()} | ` },
                            { text: 'Compañía: ', font: { bold: true } },
                            { text: `${this.nameCompania}` },
                        ]
                    };
                    cell2.font = { name: 'Arial', size: 12 };
                    cell2.alignment = { horizontal: 'center', vertical: 'middle' };

                }
                
                
                // Agregar información del contrato si está en detalle
                if (this.mostrarDetalleContrato && this.hasInfoContrato) {
                    worksheet.addRow(['']);
                    worksheet.addRow([
                        'Información del Contrato:',
                        '',
                        '',
                        '',
                        '',
                        '',
                        '',
                        ''
                    ]);
                    worksheet.mergeCells('A3:G3');
                    worksheet.getCell('A3').font = { bold: true };
                    
                    worksheet.addRow([
                        'Contrato:',
                        this.contratoSeleccionado || '',
                        'Fecha Inicial:',
                        this.infoContrato.fechaInicial || '',
                        'Fecha Final:',
                        this.infoContrato.fechaFinal || '',
                        'Tipo:',
                        this.infoContrato.tipoContrato || ''
                    ]);
                    
                    worksheet.addRow([
                        'Proveedor:',
                        this.infoContrato.proveedor || '',
                        '',
                        '',
                        '',
                        '',
                        '',
                        ''
                    ]);
                    worksheet.mergeCells('A5:B5');
                    
                    // Fila en blanco después de la información
                    worksheet.addRow(['']);
                }
                
                // Encabezados de columnas
                // const startRow = this.mostrarDetalleContrato ? 7 : 4;
                worksheet.addRow(['']);
                
                let tituloCelda = [];
                
                // Determinar los encabezados según el modo
                if (this.mostrarDetalleContrato && this.contratoSeleccionado) {
                    // Encabezados para detalle de contrato
                    tituloCelda = [
                        'Cuenta',
                        'Nombre',
                        'Tipo Activo',
                        'Centro Costo',
                        'Saldo'
                    ];
                    
                    const headerRow = worksheet.addRow(tituloCelda);
                    headerRow.alignment = { horizontal: 'center' };
                    headerRow.font = {
                        name: 'Arial',
                        size: 11,
                        bold: true
                    };
                    
                    // Agregar datos del detalle
                    datosExcel.map((e) => {
                        worksheet.addRow([
                            e.cuenta || '',
                            e.nombre || '',
                            e.tipo_activo || '',
                            e.centro_costo || '',
                            e.saldo || 0
                        ]);
                    });
                    
                } else {
                    // Encabezados para vista general
                    tituloCelda = [
                        'Contrato',
                        'Cuenta',
                        'Nombre',
                        'Proveedor',
                        'Tipo Activo',
                        'Centro Costo',
                        'Saldo'
                    ];
                    
                    const headerRow = worksheet.addRow(tituloCelda);
                    headerRow.alignment = { horizontal: 'center' };
                    headerRow.font = {
                        name: 'Arial',
                        size: 11,
                        bold: true
                    };
                    
                    // Agregar datos generales
                    datosExcel.map((e) => {
                        worksheet.addRow([
                            e.nro_contrato || '',
                            e.cuenta || '',
                            e.nombre || '',
                            this.proveedor(e.identificacion) || '',
                            e.tipo_activo || '',
                            e.centro_costo || '',
                            e.saldo || 0
                        ]);
                    });
                }
                
                // Aplicar bordes
                const border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };

                if (this.mostrarDetalleContrato && this.contratoSeleccionado) {
                    
                    for (let row = 1; row <= worksheet.rowCount; row++) {
                        if ([1, 2, 3, 4, 5].includes(row)) continue;
                        for (let col = 1; col <= worksheet.columnCount; col++) {
                            worksheet.getCell(row, col).border = border;
                        }
                    }

                } else {

                    for (let row = 1; row <= worksheet.rowCount; row++) {
                        if ([1, 2, 3].includes(row)) continue;
                        for (let col = 1; col <= worksheet.columnCount; col++) {
                            worksheet.getCell(row, col).border = border;
                        }
                    }
                }                
                
                // Ajustar ancho de columnas automáticamente
                worksheet.columns.forEach((column) => {
                    let maxLength = 10;
                    column.eachCell({ includeEmpty: true }, (cell) => {
                        const columnLength = cell.value ? cell.value.toString().length : 10;
                        if (columnLength > maxLength) {
                            maxLength = columnLength;
                        }
                    });
                    column.width = Math.min(maxLength + 2, 30);
                });
                
                // Generar y descargar archivo
                const file = await workbook.xlsx.writeBuffer();
                const downloadLink = document.createElement("a");
                
                let nombreArchivo = '';
                if (this.mostrarDetalleContrato && this.contratoSeleccionado) {
                    nombreArchivo = `Saldos_Contrato_${this.contratoSeleccionado}_${this.fechaSaldos}.xlsx`;
                } else {
                    nombreArchivo = `Saldos_por_Contrato_${this.fechaSaldos}.xlsx`;
                }
                
                downloadLink.download = nombreArchivo;
                downloadLink.href = window.URL.createObjectURL(
                    new Blob([file], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    })
                );
                downloadLink.style.display = "none";
                document.body.appendChild(downloadLink);
                downloadLink.click();
                downloadLink.remove();
                
                this.$toast.success(
                    this.$store.state._language === 'es-ES'
                        ? 'Excel generado exitosamente.'
                        : 'Excel generated successfully.'
                );
                
            } catch (error) {
                console.error('Error generando Excel:', error);
                this.$toast.error(
                    this.$store.state._language === 'es-ES'
                        ? 'Error al generar el Excel.'
                        : 'Error generating Excel.'
                );
            } finally {
                this.isLoading = false;
            }
        },
        
        async genExcelSaldContabPorCuent(){
            alert('BBB')
            try {
                if (!this.lstSaldPorCuenta || this.lstSaldPorCuenta.length === 0) {
                    this.$toast.warning(
                        this.$store.state._language === 'es-ES'
                            ? 'No hay datos para generar el Excel.'
                            : 'No data to generate Excel.'
                    );
                    return;
                }
                
                const {Workbook} = XLSX;
                const workbook = new Workbook();
                const worksheet = workbook.addWorksheet("Saldos por cuenta " + this.fechaSaldos);
                
                const titulo = ["Saldos por cuenta - " + this.fechaSaldos];
                worksheet.addRow(titulo);
                worksheet.mergeCells('A1:B1');
                worksheet.getCell('A1').font = { bold : true, size : 12};
                worksheet.getCell('A1').alignment = { horizontal : 'center'};
                
                const tituloCelda = [
                    'Cuenta',
                    'Nombre'
                ];
                
                worksheet.addRow(tituloCelda);
                for (let fila = 1; fila <= 2; fila++) {
                    worksheet.getRow(fila).font = { 
                        name: "Arial Black",
                        family: 2,
                        size: 11,
                        bold: true
                    };
                }
                
                this.lstSaldPorCuenta.map((e) => {
                    worksheet.addRow([
                        e.cuenta || '',
                        e.nombre || '',
                    ]);
                });
                
                const border = {
                    top : {style : 'thin'},
                    left : {style : 'thin'},
                    bottom : {style : 'thin'},
                    right : {style : 'thin'},
                };
                
                for( let row = 1; row <= worksheet.rowCount; row++){ 
                    for( let col = 1; col <= worksheet.columnCount; col++){ 
                        worksheet.getCell(row, col).border = border;
                    }
                }
                
                const file = await workbook.xlsx.writeBuffer();
                const downloadLink = document.createElement("a");
                downloadLink.download = "Saldos por cuenta " + this.fechaSaldos + ".xlsx";
                downloadLink.href = window.URL.createObjectURL(
                    new Blob([file], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    })
                );
                downloadLink.style.display = "none";
                document.body.appendChild(downloadLink);
                downloadLink.click();
                downloadLink.remove();
                
                this.$toast.success(
                    this.$store.state._language === 'es-ES'
                        ? 'Excel generado exitosamente.'
                        : 'Excel generated successfully.'
                );
                
            } catch (error) {
                console.error('Error generando Excel por cuenta:', error);
                this.$toast.error(
                    this.$store.state._language === 'es-ES'
                        ? 'Error al generar el Excel.'
                        : 'Error generating Excel.'
                );
            }
        },
        
        fechaActual(){
            const fecha = new Date();
            const año = fecha.getFullYear();
            const mes = String(fecha.getMonth() + 1).padStart(2, '0');
            const dia = String(fecha.getDate()).padStart(2, '0');
            return `${año}-${mes}-${dia}`;
        },
        fechaIni(contrato) {
            const contratoEncontrado = this.listContratos.find(
                c => String(c.nro_contrato) === String(contrato)
            );

            return contratoEncontrado.fecha_inicial || null;
        },
        fechaFin(contrato) {
            const contratoEncontrado = this.listContratos.find(
                c => String(c.nro_contrato) === String(contrato)
            );

            return contratoEncontrado.fecha_final || null;
        },

        tipoContrato(contrato){
            const contratoEncontrado = this.listContratos.find(
                c => String(c.nro_contrato) === String(contrato)
            );

            const tipoContrato  = this.listTipoContrato.find(
                tc => (tc.tipo_contrato) == contratoEncontrado.tipo_contrato
            );

            return tipoContrato.descripcion || null;
        },

        proveedorName(contrato){
            const contratoEncontrado = this.listContratos.find(
                c => String(c.nro_contrato) === String(contrato)
            );

            return this.proveedor(contratoEncontrado.identificacion) || null;
        }
    },
    mounted(){
        Tercero.getAllTercero() 
        .then((res) => { 
            this.listTercero = res.data.listTercero || [];
        })
        .catch((err) => console.error('Error cargando terceros:', err));

        ContratoSaldos.getListadoFechas() 
        .then((res) => { 
            this.lstFechaSaldos = res.data.lstFechaSaldo || [];
        })
        .catch((err) => console.error('Error cargando fechas:', err));

        Authentication.leaParametros() 
        .then ((result) => { 
            this.nameCompania = result.data.parametros.compania || '';
        })
        .catch((err) => console.error('Error cargando parámetros:', err));

        Contrato.getAllContratos()
        .then((res) => { 
            this.listContratos = res.data.listContratos
        })
        .catch((err) => console.log(err))

        TipoContrato.getAllTipoContrato()
        .then((res) => { 
            this.listTipoContrato = res.data.listTipoContrato
        })
        .catch((err) => console.log(err))
    },
    watch:{
        fechaSaldos(val){
            if(val == ""){
                this.lstSaldos = [];
                this.showToolbarExtras = false;
                this.mostrarDetalleContrato = false;
                this.contratoSeleccionado = null;
                this.vigenciaSeleccionada = null;
                this.limpiarInfoContrato();
            }
        }
    }
}
</script>

<style scoped>
/* Estilos optimizados */
.niif-header .filters-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    margin-left: 0 !important;
}

.niif-header .filter-select {
    min-width: 200px;
    max-width: 280px;
    width: auto;
    height: 38px;
    font-size: 14px;
    border-radius: 7px;
}

.niif-header .filter-select option {
    white-space: normal;
    word-break: break-word;
    padding: 4px 8px;
}

.niif-header .consult-btn {
    height: 38px;
    min-height: 38px;
    padding: 0 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 14px;
    background-color: #6c757d !important;
    color: white !important;
    border: 1px solid #6c757d !important;
    cursor: pointer;
    flex-shrink: 0;
    transition: opacity 0.2s;
}

.niif-header .consult-btn:hover:not(:disabled) {
    background-color: #5a6268 !important;
    border-color: #545b62 !important;
}

.niif-header .consult-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

.page-back-btn {
    padding: 0;
    font-size: 1.5rem;
    line-height: 1;
}

.back-icon {
    font-size: 1.75rem !important;
    width: 1.75rem !important;
    height: 1.75rem !important;
}

.param-title {
    font-size: 2rem !important;
    font-weight: 500;
}

.niif-toolbar-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex: 0 0 auto;
}

.table-toolbar-excel-btn {
    height: 31px;
    min-height: 31px;
    padding: 0 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 13px;
    background-color: #016690;
    color: white;
    border: 1px solid #085170;
    transition: background-color 0.2s, opacity 0.2s;
}

.table-toolbar-excel-btn:hover:not(:disabled) {
    background-color: #085170;
    border-color: #0e3a4d;
}

.table-toolbar-excel-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

/* Responsive */
@media (max-width: 992px) {
    .niif-header .filters-container {
        flex-wrap: wrap;
        width: 100%;
        margin-top: 8px;
        justify-content: flex-start;
        gap: 6px;
    }

    .niif-header .filter-select {
        min-width: 150px;
        max-width: 200px;
        height: 36px;
        font-size: 13px;
        flex: 1 1 auto;
    }

    .niif-header .consult-btn {
        height: 36px;
        min-height: 36px;
        font-size: 13px;
        padding: 0 16px;
    }
}

@media (max-width: 576px) {
    .param-title {
        font-size: 1.5rem !important;
    }

    .niif-header .filter-select {
        min-width: 100%;
        max-width: 100%;
        height: 36px;
        font-size: 13px;
        flex: 0 0 100%;
    }

    .niif-header .filters-container {
        gap: 4px;
    }

    .niif-header .consult-btn {
        width: 100%;
        flex: 0 0 100%;
        height: 36px;
        margin-left: 0 !important;
        margin-top: 4px;
    }
}

/* Estilos para la información del contrato */
.detail-contrato {
    display: flex;
    align-items: center;
    padding: 8px 16px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #dee2e6;
    min-width: 400px;
    flex-shrink: 0;
}

.contract-info-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 4px 20px;
    width: 100%;
}

.info-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    padding: 2px 0;
    white-space: nowrap;
}

.info-label {
    color: #6c757d;
    font-weight: 500;
    margin-right: 8px;
}

.info-value {
    color: #212529;
    font-weight: 600;
    text-align: right;
}

/* Botón de volver en detalle */
.back-detail-btn {
    height: 38px;
    min-height: 38px;
    padding: 0 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 14px;
    flex-shrink: 0;
    border-color: #6c757d;
    color: #6c757d;
}

.back-detail-btn:hover {
    background-color: #6c757d;
    color: white;
}

/* Responsive para la información del contrato */
@media (max-width: 1200px) {
    .detail-contrato {
        min-width: 300px;
        padding: 6px 12px;
    }
    
    .contract-info-grid {
        gap: 2px 12px;
    }
    
    .info-item {
        font-size: 12px;
    }
}

@media (max-width: 992px) {
    .niif-header .d-flex.align-items-center.w-100 {
        flex-wrap: wrap;
        gap: 8px;
    }
    
    .detail-contrato {
        margin-left: 0 !important;
        width: 100%;
        min-width: unset;
        flex-wrap: wrap;
    }
    
    .contract-info-grid {
        grid-template-columns: 1fr 1fr;
        width: 100%;
    }
    
    .back-detail-btn {
        height: 36px;
        font-size: 13px;
        padding: 0 16px;
    }
}

@media (max-width: 576px) {
    .detail-contrato {
        padding: 8px 10px;
    }
    
    .contract-info-grid {
        grid-template-columns: 1fr;
        gap: 2px;
    }
    
    .info-item {
        font-size: 11px;
        padding: 1px 0;
    }
    
    .back-detail-btn {
        width: 100%;
        flex: 0 0 100%;
        height: 36px;
        margin-left: 0 !important;
        margin-top: 4px;
    }
}

/* Estilos para la información del contrato en una sola fila */
.detail-contrato {
    display: flex;
    align-items: center;
    padding: 6px 16px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #dee2e6;
    flex-shrink: 0;
    margin-left: auto !important;
    gap: 8px;
    font-size: 13px;
    flex-wrap: nowrap;
}

.info-item {
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
}

.info-label {
    color: #6c757d;
    font-weight: 500;
    margin-right: 4px;
}

.info-value {
    color: #212529;
    font-weight: 600;
}

.info-divider {
    color: #dee2e6;
    font-weight: 300;
    margin: 0 2px;
}

/* Responsive para la información del contrato */
@media (max-width: 1200px) {
    .detail-contrato {
        font-size: 12px;
        padding: 4px 12px;
        gap: 6px;
    }
    
    .info-divider {
        margin: 0 1px;
    }
}

@media (max-width: 992px) {
    .niif-header .d-flex.align-items-center.w-100 {
        flex-wrap: wrap;
        gap: 8px;
    }
    
    .detail-contrato {
        margin-left: 0 !important;
        width: 100%;
        flex-wrap: wrap;
        justify-content: flex-start;
        padding: 6px 12px;
        gap: 4px 12px;
    }
    
    .info-divider {
        display: none;
    }
    
    .info-item {
        white-space: normal;
    }
}

@media (max-width: 576px) {
    .detail-contrato {
        font-size: 11px;
        padding: 4px 8px;
        gap: 2px 8px;
    }
    
    .info-label {
        margin-right: 2px;
    }
}
</style>
